import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../../../Admin/Company/CompanyWizard/Stores/Variable";
import { AccountRoleStatic } from "./AccountRoleStatic";
import { AccountSearchStatic } from "./AccountSearchStatic";
import { AdditionalDataItemStatic } from "./AdditionalDataItemStatic";
import { ClientRecordStatic } from "./ClientRecordStatic";
import { ClientServicePropositionStatic } from "./ClientServicePropositionStatic";
import { CustomerSearchStatic } from "./CustomerSearchStatic";
import { OrganisationSearchStatic } from "./OrganisationSearchStatic";

export const ClientRecordDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ClientRecordStore: ClientRecordStatic = new ClientRecordStatic();
export const ClientServicePropositionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ClientServicePropositionStore: ClientServicePropositionStatic = new ClientServicePropositionStatic();
export const AccountSearchDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AccountSearchStore: AccountSearchStatic = new AccountSearchStatic();
export const CustomerSearchDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CustomerSearchStore: CustomerSearchStatic = new CustomerSearchStatic();
export const OrganisationSearchDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const OrganisationSearchStore: OrganisationSearchStatic = new OrganisationSearchStatic();

export const AccountRoleDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AccountRoleStore: AccountRoleStatic = new AccountRoleStatic();

export const AdditionalDataItemDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AdditionalDataItemStore: AdditionalDataItemStatic = new AdditionalDataItemStatic();
